import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { updateSetting } from 'store/actions/settings'
import { getFiltersForSearch } from 'services/Utilities'
import { isEqual } from 'lodash'
import { MFilters } from 'types/filterTypes'

const useFiltersChange = (contentName: MFilters.ContentTypes): { filtersHaveChanged: boolean; triggerSearch: () => void } => {
  const dispatch = useDispatch()

  const filterKey: MFilters.FilterKey = `filter-${contentName}`
  const filterParsedKey: MFilters.FilterParsedKey = `search-content-parsed-${contentName}`
  const settings = useSelector((state: MStore.RootState) => state.settings)
  const savedOptions = useMemo(() => {
    return settings[filterKey] || {}
  }, [settings, filterKey])
  const savedParsedOptions = useMemo(() => {
    return settings[filterParsedKey] || {}
  }, [settings, filterParsedKey])

  // Check if the saved options are different from the current search
  const filtersHaveChanged = useMemo(() => {
    const newFilter = getFiltersForSearch(savedOptions)
    return !isEqual(newFilter, savedParsedOptions)
  }, [savedOptions, savedParsedOptions])

  const triggerSearch = () => {
    // Trigger research
    // TODO: Find out why we can't use useUpdateSettings
    dispatch(updateSetting(filterKey, savedOptions))
    dispatch(updateSetting(filterParsedKey, getFiltersForSearch(savedOptions)))
  }

  return { filtersHaveChanged, triggerSearch }
}

export default useFiltersChange
